<!-- ── Toolbar: search + new ─────────────────────────────────────────────── -->
<div class="list-brands__toolbar">
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'common.search' | translate"
    class="list-brands__search">
  </ui-form-field>
  <div class="list-brands__toolbar-actions">
    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->
    <ui-button
      *appHasPermission="{ module: 'product', action: 'create' }"
      type="primary"
      icon="plus-cc"
      iconSize="large"
      [label]="('common.new' | translate) + ' ' + ('brands.brand' | translate)"
      (click)="openBrand()">
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-brands__table" [class.list-brands__table--with-bulk-bar]="selection.hasSelection">
  <div class="list-brands__table-scroll">

    <!-- Header -->
    <div class="list-brands__table-header">
      <div class="list-brands__table-cell list-brands__table-cell--checkbox" (click)="$event.stopPropagation()">
        <ui-checkbox
          [checked]="selection.isAllSelected"
          [indeterminate]="selection.isPartialSelected"
          [ariaLabel]="'common.select_all' | translate"
          (changed)="selection.toggleAll($event.checked)">
        </ui-checkbox>
      </div>
      <div class="list-brands__table-cell">{{ 'common.image' | translate }}</div>
      <div class="list-brands__table-cell">{{ 'common.name' | translate }}</div>
      <div class="list-brands__table-cell">{{ 'common.code' | translate }}</div>
      <div class="list-brands__table-cell">{{ 'common.description' | translate }}</div>
      <div class="list-brands__table-cell">{{ 'brands.total_products' | translate }}</div>
    </div>

    <!-- Loading state -->
    <div class="list-brands__loading" *ngIf="isAppLoading$ | async">
      <div class="list-brands__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(isAppLoading$ | async) && (brands$ | async) as brands">
      <ng-container *ngIf="brands.length > 0">
        <div *ngFor="let brand of brands"
          class="list-brands__table-row"
          (click)="openBrand(brand)">
          <div class="list-brands__table-cell list-brands__table-cell--checkbox" (click)="$event.stopPropagation()">
            <ui-checkbox
              [checked]="selection.isSelected(brand.id)"
              [ariaLabel]="brand.name"
              (changed)="selection.toggleOne(brand.id, $event.checked, $event)">
            </ui-checkbox>
          </div>
          <div class="list-brands__table-cell">
            <img *ngIf="brand.image" class="list-brands__thumb" [src]="getImage(brand.image)" alt="">
            <img *ngIf="!brand.image" class="list-brands__thumb list-brands__thumb--placeholder" src="assets/icones/default-image-product.svg" alt="">
          </div>
          <div class="list-brands__table-cell list-brands__table-cell--strong">{{ brand.name }}</div>
          <div class="list-brands__table-cell list-brands__table-cell--strong">{{ brand.code ? brand.code : '--' }}</div>
          <div class="list-brands__table-cell list-brands__table-cell--description">{{ brand?.description || '--' }}</div>
          <div class="list-brands__table-cell">{{ brand.total_products ?? 0 }}</div>
        </div>
      </ng-container>

      <!-- Empty state -->
      <div *ngIf="brands.length === 0" class="list-brands__empty">
        <ng-container *ngIf="!key">
          <img class="list-brands__empty-illustration" src="assets/icones/no-brands.svg" alt="">
          <h3>{{ 'brands.no_brands' | translate }}</h3>
        </ng-container>
        <ng-container *ngIf="key">
          <img class="list-brands__empty-illustration" src="assets/icones/no-result-search.svg" alt="">
          <h3>{{ 'brands.no_data_search' | translate }}</h3>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <!-- ─────────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ─────────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar
    *ngIf="selection.hasSelection"
    [count]="selection.count"
    (cleared)="selection.clear()">
    <button
      *appHasPermission="{ module: 'product', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()">
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination *ngIf="((brands$ | async)?.length ?? 0) > 0"
    class="list-brands__pagination"
    [pagination]="pagination$ | async"
    (toPageEvent)="toPage($event)">
  </app-pagination>
</div>
